import React, {Component} from 'react';
import {Modal, ModalBody} from 'reactstrap';

import loadingGIF from "../../public/assets/images/loading.gif";


export default class LoadingModal extends Component {
    
    render() {
        return (
            <Modal isOpen={this.props.modal} className="loading-modal">
                <ModalBody className="text-center">
                    <img src={loadingGIF} alt="loading..." />
                </ModalBody>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/LoadingModal.js